import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    GET: createAction('GLOBAL/CERIFICATES/GET'),
    ERROR: createAction('GLOBAL/CERIFICATES/ERROR'),
    SUCCESS: createAction('GLOBAL/CERIFICATES/SUCCESS'),
};
export const initialState = Map({
    isProcessing: false,
    error: false,
    certificates: [],
});
const reducer = handleActions({
    [actions.GET]: (state) => state.set('isProcessing', true),
    [actions.SUCCESS]: (state, action) => state.merge({
        isProcessing: false,
        error: false,
        certificates: action.payload,
    }),
    [actions.ERROR]: (state) => state.merge({ isProcessing: false, error: true }),
}, initialState);
export default reducer;
